// Cari Hesaplar listesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.list';

export const accountsListGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Cari Hesaplar nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Müşteri ve tedarikçi hesaplarınızı tek yerden yönetirsiniz: cari ekleme, tahsilat / ödeme, sevk adresi ve hareket raporları bu ekrandan yürür. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    stats: t(`${G}.regions.stats`, 'Bakiye kartları'),
    toolbar: t(`${G}.regions.toolbar`, 'Ekle ve ⋮ menüsü'),
    table: t(`${G}.regions.table`, 'Cari listesi'),
  },
  steps: [
    {
      region: 'stats',
      title: t(`${G}.s1.title`, '1. Bakiye kartlarını okuyun'),
      text: t(`${G}.s1.text`, 'Üstteki kartlar Toplam Net Bakiye, Toplam Alacak, Toplam Borç ve Toplam Cari Hesap sayısını gösterir. Bakiyeler tüm hareket kayıtlarından otomatik hesaplanır; tarih sınırı yoktur, açılıştan bugüne tüm borç ve alacaklar dahildir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Formül: Alacak − Borç = Bakiye.'),
        t(`${G}.s1.tip2`, 'Artı (pozitif) bakiye: carinin alacağı var, yani biz borçluyuz.'),
        t(`${G}.s1.tip3`, 'Eksi (negatif) bakiye: carinin borcu var, yani biz alacaklıyız.'),
        t(`${G}.s1.tip4`, 'Yeni bir işlem eklenince veya silinince bakiyeler kendiliğinden güncellenir.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s2.title`, '2. Cariyi bulun'),
      text: t(`${G}.s2.text`, 'Arama kutusuna cari adını yazın; Cari Grup ve Şube filtreleriyle listeyi daraltın. Şube yöneticisi olarak girdiyseniz şube filtresi kendi şubenize kilitlidir.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Cari ekleyin, ⋮ menüsünü kullanın'),
      text: t(`${G}.s3.text`, '"Yeni Cari Ekle" tek bir cari kartı açar, "Toplu Cari Ekle" birden çok cariyi bir seferde ekler. ⋮ menüsünde ek işlemler bulunur.'),
      tips: [
        t(`${G}.s3.tip1`, 'Tabloyu Özelleştir: hangi sütunların görüneceğini seçin.'),
        t(`${G}.s3.tip2`, 'Pasif Cariler: bu listede yalnız aktif cariler görünür; pasife alınanları buradan görürsünüz.'),
        t(`${G}.s3.tip3`, 'Toplu işlem, Hareket Raporu, Grup Ekle ve Excel İndir de bu menüdedir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Satırdaki işlemleri kullanın'),
      text: t(`${G}.s4.text`, 'Listede yalnız aktif cariler bulunur; Bakiye sütunu yukarıdaki kurala göre hesaplanır. Satırın sonundaki ⋮ düğmesi o cari için işlemleri açar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Tahsilat Yap, Ödeme Yap, Cariyi Borçlandır: günlük para hareketleri.'),
        t(`${G}.s4.tip2`, 'Sevk Adresi Ekle, Yazdır, Düzenle, Cari Detaylar: kart bilgileri.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Cari Raporu ile hareketleri inceleyin'),
      text: t(`${G}.s5.text`, 'Bir carinin tüm hareket geçmişini görmek için satırındaki "Cari Raporu"na tıklayın. Açılan sayfada hareket kayıtlarını ve güncel bakiyeyi görürsünüz; isterseniz tarih filtreleriyle belirli bir dönemi inceleyin.'),
      tips: [
        t(`${G}.s5.tip1`, 'Cari Raporundaki bakiye de tüm hareket kayıtları üzerinden hesaplanır.'),
        t(`${G}.s5.tip2`, 'Tarih filtresi yalnız hangi hareketlerin listeleneceğini seçer.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s6.title`, '6. Sayfalar arasında gezin'),
      text: t(`${G}.s6.text`, 'Liste uzunsa alttaki sayfalama ile ilerleyin ve sayfa başına kaç satır görüneceğini seçin. Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
    },
  ],
});
